import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate, Link } from 'react-router-dom';

import Messages from "../../../constants/Messages";
import uRLs from "../../../utils/baseUtils";
import { useShowAlert } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthProvider";
import { useNetwork } from "../../../context/NetworkContext";
import { ChevronLeftIcon } from "../../../constants/Icons";

const ForgotPassword = () => {
    const showAlert = useShowAlert();
    const navigate = useNavigate();
    const location = useLocation();

    const { handleLogin } = useAuth();
    const { checkNetwork } = useNetwork();

    const emailInputRef = useRef(null);
    const email = location.state?.email || '';
    const [isForgotData, setForgotData] = useState({ email: email });
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [error, setErrors] = useState({});
    const [errorMsg, setErrorMsg] = useState(null);

    const validateForm = () => {
        const errors = {};
        if (isForgotData.email === undefined || isForgotData.email === null || isForgotData.email === "") {
            errors.email = Messages.ERROR.EMPTY_EMAIL;
        } else if (isForgotData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(isForgotData.email)) {
            errors.email = Messages.ERROR.INVALID_EMAIL;
        }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            switch (firstErrorField) {
                case 'email':
                    emailInputRef.current?.focus();
                    break;
                default:
                    break;
            }
        }
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = (name === 'email') ? value.replace(/\s/g, '').trim().toLowerCase() : value;
        const updatedData = {
            ...isForgotData,
            [name]: cleanedValue,
        };
        setForgotData(updatedData);
    };

    const handleReset = () => {
        setErrorMsg(null);
        if (!validateForm()) return;
        handleSendOTP();
    };

    const handleSendOTP = async () => {
        setBtnLoading(true);
        try {
            if (!checkNetwork()) return;
            const response = await axios.post(`${uRLs.AUTH_URL}auth-reset-password`, isForgotData);
            showAlert("success", Messages.SUCCESS.OTP_SEND);
            navigate("/verify", { state: { email: isForgotData.email, isfrom: "FORGOT", verifyToken: response.data.results.verifyToken, label: 'Back to Login', successRedirect: 'authpassword', failureRedirect: 'forgot' } });
        } catch (error) {
            setErrorMsg(error.response?.data?.message || Messages.AUTH.OTP_FAILED);
        } finally {
            setBtnLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleReset();
        }
    };

    const handleBackLink = () => {
        navigate("/login", {
            replace: true,
            state: {
                email: isForgotData.email
            },
        });
    }

    return (
        <div class="wrapper">
            <div class="authentication-reset-password d-flex align-items-center justify-content-center">
                <div class="container">
                    <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                        <div class="col mx-auto">
                            <div class="card">
                                <div class="card-body">
                                    <div class="p-4">
                                        <div class="mb-4 text-center">
                                            <img src="assets/images/logo-icon.png" width="60" alt="" />
                                        </div>
                                        <div class="text-start mb-4">
                                            <h4 className="text-left mt-3 fw-400">Forgot Password? 🔒</h4>
                                            <p className="text-left mb-0">Enter your email and we'll send you instructions to reset your password</p>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label htmlFor="email" className="form-label">
                                                    Email <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="email"
                                                    autoComplete="off"
                                                    value={isForgotData.email}
                                                    onChange={handleChange}
                                                    ref={emailInputRef}
                                                    onKeyDown={handleKeyDown}
                                                />
                                                {error.email && <div className="invalid-feedback">{error.email}</div>}
                                            </div>

                                            {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}

                                            <div className="col-12">
                                                <div className="d-grid">
                                                    {isBtnLoading ? (
                                                        <button className="btn btn-primary pb-0" disabled>
                                                            <CircularProgress size={22} className="text-white" />
                                                        </button>
                                                    ) : (
                                                        <button type="button" onClick={handleReset} className="btn btn-primary">
                                                            Send OTP
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="text-center">
                                                    <a onClick={handleBackLink} class="d-flex align-items-center justify-content-center cursor-pointer">
                                                    <ChevronLeftIcon iClass={"me-1 fs-18"}/>
                                                        Back to Login
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;